var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAndResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 88,
    viewBox: "0 0 68 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3332 87.75H0.666504V0.25H46.4998L67.3332 21.0833V87.75Z",
    fill: "#EAEFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2082 23.1667H44.4165V3.375L64.2082 23.1667Z",
    fill: "#5679EC",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4102 66.4336C27.5156 66.4336 28.3223 66.6504 28.8301 67.084C29.3418 67.5137 29.5977 68.1309 29.5977 68.9355C29.5977 69.2988 29.5371 69.6445 29.416 69.9727C29.2988 70.2969 29.1074 70.584 28.8418 70.834C28.5762 71.0801 28.2266 71.2754 27.793 71.4199C27.3633 71.5605 26.8359 71.6309 26.2109 71.6309H25.168V75H24.1719V66.4336H26.4102ZM26.3164 67.2832H25.168V70.7754H26.0996C26.6465 70.7754 27.1016 70.7168 27.4648 70.5996C27.832 70.4824 28.1074 70.293 28.291 70.0312C28.4746 69.7656 28.5664 69.4141 28.5664 68.9766C28.5664 68.4062 28.3848 67.9824 28.0215 67.7051C27.6582 67.4238 27.0898 67.2832 26.3164 67.2832ZM38.1934 70.6348C38.1934 71.5996 38.0176 72.4062 37.666 73.0547C37.3145 73.6992 36.8047 74.1855 36.1367 74.5137C35.4727 74.8379 34.666 75 33.7168 75H31.3906V66.4336H33.9746C34.8457 66.4336 35.5957 66.5938 36.2246 66.9141C36.8535 67.2305 37.3379 67.7012 37.6777 68.3262C38.0215 68.9473 38.1934 69.7168 38.1934 70.6348ZM37.1445 70.6699C37.1445 69.9004 37.0156 69.2656 36.7578 68.7656C36.5039 68.2656 36.1289 67.8945 35.6328 67.6523C35.1406 67.4062 34.5371 67.2832 33.8223 67.2832H32.3867V74.1445H33.5996C34.7793 74.1445 35.6641 73.8535 36.2539 73.2715C36.8477 72.6895 37.1445 71.8223 37.1445 70.6699ZM41.0938 75H40.0977V66.4336H44.8672V67.3125H41.0938V70.4531H44.6387V71.3262H41.0938V75Z",
    fill: "#5679EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAndResources);
export default __webpack_public_path__ + "static/media/documentAndResources.97a29ced.svg";
export { ForwardRef as ReactComponent };